import { create } from 'zustand';
import { DEFAULT_CONFIG } from './constants';
import type { AppConfig } from './types';

interface AppState {
  config: AppConfig;
  isRecording: boolean;
  isMobile: boolean;
  setConfig: (config: AppConfig | ((prev: AppConfig) => AppConfig)) => void;
  setIsRecording: (isRecording: boolean) => void;
  setIsMobile: (isMobile: boolean) => void;
}

export const useAppStore = create<AppState>((set) => ({
  config: DEFAULT_CONFIG,
  isRecording: false,
  isMobile: false,
  setConfig: (config) => 
    set((state) => ({ 
      config: typeof config === 'function' ? config(state.config) : config 
    })),
  setIsRecording: (isRecording) => set({ isRecording }),
  setIsMobile: (isMobile) => set({ isMobile }),
}));
